module.exports = __webpack_public_path__ + "img/exmpl-ui_space-canvas.fdf13ce0.png";